<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="this.titleinvoice +' '+ $t('invoices')"
          :directory="$t('datatables')"
          :icon="'grid'"/>
      </div>
      <div class="col-sm-12 col-md-6 breadcrumb-side-button">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            v-if="userRole.role != 'Buyer'"
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openAddEditModal"
          >
            {{ $t("create_invoice") }}
          </button>
        </div>
      </div>
    </div>
    <app-table
      :id="tableId"
      :options="options"
      @action="getListAction"
    />

    <invoice-addmodal
      v-if="isAddEditModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      :closeAddEditModal="closeAddEditModal"
      @close-modal="closeAddEditModal"
    />
    <invoice-editmodal
      v-if="isEditModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      :closeAddEditModal="closeEditModal"
      @close-modal="closeEditModal"
    />
    <app-delete-modal
            v-if="deleteConfirmationModalActive"
            :preloader="deleteLoader"
            modal-id="demo-delete"
            @confirmed="confirmed"
            @cancelled="cancelled"
        />

  </div>
</template>

<script>
// import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../Config/ApiUrl";
import { TableHelpers } from "../../Demo/Tables/mixins/TableHelpers";
import { axiosGet, axiosDelete } from '../../../../Helpers/AxiosHelper';

export default {
  // extends: CoreLibrary,
  name: "tab-filter",
  mixins: [TableHelpers],
  props: {
    id: Number,
  },
  data() {
    return {
      invoice: {},
      isAddEditModalActive: false,
      isEditModalActive:false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: "",
      titleinvoice: "",
      tableId: "filter-without-wrapper",
      filteredData: {
        status: "",
      },
      search: "",
      rowData: {},
      options: {
        name: this.$t("tab_filter"),
        url: actions.COMPANY_INVOICE_LIST,
        datatableWrapper: false,
        tableShadow: false,
        showHeader: true,
        columns: [
          {
            title: this.$t("invoice_#"),
            type: "custom-html",
            key: "invoice_number",
            modifier: (value, row) => {
                return `<a href="#" id="${row.id}"  data-attribute="${row.id}" @click=${this.myFunction(row.id)}>${this.$t(value)}</a>`; 
            },
          },
          // {
          //   title: this.$t("customers"),
          //   type: "custom-html",
          //   key: "company_name",
          //   modifier: (value) => {
          //     let company_name = value ;
          //     this.titleinvoice = company_name;
          //     return `<span>${this.$t(value.company_name)}</span>`;
          //   },
          // },
          {
            title: this.$t("invoice_date"),
            type: "custom-html",
            key: "invoice_date",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("due_date"),
            type: "custom-html",
            key: "due_date",
            modifier: (value) => {
              var result = '';
              if (value == null) {
                result = "---";
              }
              else {
                var now = moment(); // Get the current date and time
                var dueDate = moment(value); // Parse the due date

                if (dueDate.isBefore(now)) {
                    result = 'Due Date Passed';
                }
                else {
                    var diff = dueDate.diff(now, 'minutes');
                    if (diff < 60) {
                        result = diff + ' minutes';
                    } else if (diff < 1440) {
                        result = Math.round(diff / 60) + ' hours';
                    } else {
                        result = dueDate.diff(now, 'days') + ' days';
                    }  
                }
              }
              return `<span>${this.$t(result)}</span>`;
            },
          },
          {
            title: this.$t("total"),
            type: "custom-html",
            key: "amount",
            modifier: (value) => {
              return `<span>${this.$t(value.toString())}</span>`;
            },
          },
          {
            title: this.$t("paid_due"),
            type: "custom-html",
            key: "amount_due",
            modifier: (value) => {
              return `<span>${this.$t(value.toString())}</span>`;
            },
          },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "status",
            isVisible: true,
             modifier: (value) => {
              let ClassName = "danger";
              let val = ''

              if (value === "succeeded") 
              {
                ClassName = `success`;
                val = 'Paid';
              } 
              else if (value === "pending") 
              {
                ClassName = `warning`;
                val = 'Overdue';
              }
              
              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                val
              )}</span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("Action"),
            icon: "edit",
            type: "none",
          },
          {
            title: this.$t("view"),
            icon: "eye",
            type: "none",
            // component: "app-add-modal",
            // modalId: "demo-add-edit-Modal",
          },
          {
              title: this.$t('reminder'),
              type: 'none',
              icon: 'clock',
          },
          {
              title: this.$t('export_pdf'),
              type: 'none',
              icon: 'download',
          },
          // {
          //     title: this.$t('print'),
          //     type: 'none',
          // },
          {
              title: this.$t('delete'),
              icon: 'trash',
              type: 'none',
              component: 'app-confirmation-modal',
              modalId: 'demo-delete',
          }
        ],
        showFilter: false,
        // showSearch: true,
        showCount: true,
        // showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
      userFilterOptions: [
        { id: "", value: "All Invoices" },
        { id: "succeeded", value: "Paid" },
        { id: "pending", value: "Un Paid" },
        // { id: "invited", value: "Invited" },
      ],
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    // this.searchAndSelectFilterOptions();
  },
  methods: {
    // getSearchValue(value) {
    //   let instance = this;
    //   this.search = value;
    //   setTimeout(function () {
    //     instance.$hub.$emit("reload-" + instance.tableId);
    //   });
    // },
    // getFilterValue(item) {
    //   this.filteredData.status = item;
    //   
    //   this.$hub.$emit("reload-" + this.tableId);
    // },
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    closeAddEditModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isAddEditModalActive = false;
      this.getFilterValue();
      this.reSetData();
    },
    closeEditModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isEditModalActive = false;
      this.getFilterValue();
      this.reSetData();
    },
    getListAction(rowData, actionObj, active) {
            this.rowData = rowData;

            // if (actionObj.title == 'Download') {
            //   this.download = true;

            //     this.getInvoiceDownload(rowData.id);
            //     this.generateReport();
            // } else 
            if (actionObj.title == this.$t('view')) {

                // window.location = '/admin/invoice/view/'+ rowData.id;
                // this.active = 3;
                // this.$emit("invoiceId", rowData.id);
                this.view(rowData.id);
            }
            else if (actionObj.title == this.$t('Action'))
            {
              if (rowData.status == 'succeeded')
              {
                this.$toastr.s('You are already paid customer');
              }
              else
              {
                this.selectedUrl = `${actions.SINGLE_INVOICE_SHOW}/${rowData.id}`;
                this.isEditModalActive = true;
              }
            }
            else if (actionObj.title == 'Reminder') {
              // this.copyInvoice();
            }
            else if (actionObj.title == this.$t("export_pdf")) {
              this.invoicePdf();
            }
            
            else if (actionObj.title == 'Delete') {
              // this.copyInvoice();
              this.openDeleteModal();
            }
        },

    view(id) {
        this.active = 3;
        this.$emit("invoiceId", id);
    },
     myFunction(id){
        let doc = document.getElementById(id);
        if(doc){
            doc.addEventListener('click', () => {
            this.view(doc.dataset.attribute)
            }) 
        }
        },
        invoicePdf() {
      // alert('a');
      let url = `${actions.INVOICE_PDF}/${this.rowData.id}`;
       window.location = url;

      // router.push(url);
      this.preLoader = true;
      // axiosGet(url)
      //   .then((response) => {
      //     this.deleteLoader = false;
      //     // $("#demo-delete").modal("hide");
      //     // this.cancelled();
      //     this.$toastr.s(response.data.message);
      //     // this.searchAndSelectFilterOptions();
      //   })
      //   .catch(({ error }) => {
      //     // Trigger after error
      //   })
      //   .finally(() => {
      //     this.$hub.$emit("reload-" + this.tableId);
      //   });

    },

    /**
     * for open confirmation modal
     */
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    /**
     * confirmed $emit Form confirmation modal
     */
    confirmed() {
      let url = `${actions.INVOICE_DESTROY}/${this.rowData.id}`;
      this.deleteLoader = true;
      axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#demo-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(response.data.message);
          this.searchAndSelectFilterOptions();
        })
        .catch(({ error }) => {
          // Trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    /**
     * cancelled $emit Form confirmation modal
     */
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },
    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
    getCompanyName() {
      // let myLocation = location.href;
      // let split = myLocation.split('/');
      
      // let id = split[6].split('?')[0];
      
      axiosGet(actions.COMPANY_NAME+'/'+ this.id)
      .then((response) => {
          
          this.titleinvoice = response.data.company_name;
        })
        .catch((error) => {
          
        });
    },

    getInvoice() {
        // let myLocation = location.href;
        // let split = myLocation.split("/");
        // let split_ = split[6].split("?");
        
        // let a = this.options.url.append(this.id);
        
        // this.options.url = this.options.url + '/' + split_[0];
        this.options.url = this.options.url + '/' + this.id;
    }
    
  },
  mounted() {

    // this.getInvoiceDownload();
    this.getInvoice();
    this.getCompanyName();
  },
  computed: {
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
  },
};
</script>
